import { render, staticRenderFns } from "./PersonalizedGameEditorMockup.vue?vue&type=template&id=4c618b2f&scoped=true&"
import script from "./PersonalizedGameEditorMockup.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c618b2f",
  null
  
)

export default component.exports